export class FmCommon {
  static get AppName() {
    return 'Fish Mate';
  }

  static get DateFullYear() {
    return new Date().getFullYear();
  }
}
